import { render, staticRenderFns } from "./ModalContentEditReminder.vue?vue&type=template&id=9a8b2278&scoped=true&"
import script from "./ModalContentEditReminder.vue?vue&type=script&lang=js&"
export * from "./ModalContentEditReminder.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentEditReminder.vue?vue&type=style&index=0&id=9a8b2278&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8b2278",
  null
  
)

export default component.exports